export default __webpack_public_path__ + "static/media/23.21bd8773.jpg";